<template>
  <div class="view-layout" :key="change">
    <m-widget-head class="content-widget-head">
      <div class="caption">{{ $t('menu.bonuses') }}</div>
    </m-widget-head>
    <div class="content-layout">
      <m-scrollbar>
        <iframe :src="src" data-anchor="" scrolling="no" width="100%" height="100%" frameborder="0" :style="{marginTop: '5px'}" ></iframe>
      </m-scrollbar>
    </div>
  </div>
</template>

<script>
import MWidgetHead from '@/components/widget/MWidgetHead'
import MScrollbar from '@/components/MScrollbar'

export default {
  components: { MWidgetHead, MScrollbar },
  data () {
    return {
      change: this.$i18n.locale,
      src: 'https://api.betspectrum.com/bonus/getData?user=' + this.$store.state.user.id + '&isMobile=false&lang=' + this.$i18n.locale
    }
  },
  mounted () {
    this.change = this.$i18n.locale
    this.src = 'https://api.betspectrum.com/bonus/getData?user=' + this.$store.state.user.id + '&isMobile=false&lang=' + this.$i18n.locale
  },
  watch: {
    '$i18n.locale' (to, from) {
      this.change = this.$i18n.locale
      this.src = 'https://api.betspectrum.com/bonus/getData?user=' + this.$store.state.user.id + '&isMobile=false&lang=' + this.$i18n.locale
    }
  }
}
</script>

<style scoped>
.view-layout { height: 100%; }
.content-layout { height: 100%; margin-top: -40px; padding: 50px 0 10px; }
.content-widget-head { margin: 0 10px; }
</style>



// WEBPACK FOOTER //
// src/components/account/bonuses/View.vue